<template>
  <div>
    <breadcrumbPage></breadcrumbPage>
    <div class="content EC_width">
      <div class="product_bar">
        <div class="imgTip">
          <img src="/image/english/imgTip.png"
               style="width: 222px">
        </div>
        <div class="productWrap">
          <div class="p_title"><img src="/image/english/activeorigin.png"
                 class="marginRight5">{{apiData.title}}</div>
          <div class="p_title_sub">{{apiData.titleSub}}</div>
          <div class="p_instro_bar">
            <div class="flex1">
              <p class="top_instro">ISSN</p>
              <p class="down_instro">1234-1234</p>
            </div>
            <div class="flex1">
              <p class="top_instro">ISSN</p>
              <p class="down_instro">1234-1234</p>
            </div>
          </div>
          <div class="p_instro_bar">
            <div class="flex1">
              <p class="top_instro">ISSN</p>
              <p class="down_instro">1234-1234</p>
            </div>
            <div class="flex1">
              <p class="top_instro">ISSN</p>
              <p class="down_instro">1234-1234</p>
            </div>
          </div>
          <div class="p_btn_bara">
            <a href="javascript:;"
               class="p_btn"><img src="/image/english/btnimg1.png"
                   class="imgvertical-4 marginRight5">submit</a>
            <a href="javascript:;"
               class="p_btn anse"><img src="/image/english/btnimg2.png"
                   class="imgvertical-4 marginRight5">submit</a>
            <a href="javascript:;"
               class="p_btn anse"><img src="/image/english/btnimg3.png"
                   class="imgvertical-4 marginRight5">submit</a>
          </div>
        </div>
      </div>
      <div class="timeSet">
        <div class="positionBtn marginBottom40">
          <swiper :options="swiperOption"
                  ref="mySwiper"
                  class="imgBanner">
            <swiper-slide v-for="(item,index) in apiData.yearNum"
                          :key="'0'+index">
              <a href="javascript:;"
                 :class="{timeItem_active:yearTagindex==index}"
                 class="timeItem"
                 @click="yearClick(item,index)">
                {{item}}
              </a>
            </swiper-slide>
          </swiper>
          <div class="prevbutton">&lt;</div>
          <div class="nextbutton">&gt;</div>
        </div>
        <div class="listNews"
             v-for="(item,index) in apiData.news"
             :key="index">
          <img src="/image/icon/lv14.png"
               class="listNewsActive">
          <a href="javascript:;">
            <span class="date">{{item.date}}</span>
            <span class="intro_text">{{item.title}}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumbPage from "../home/breadcrumbPage"
export default {
  name: "enLiteList",
  data () {
    return {
      apiData: {},
      yearTagindex: "",
      swiperOption: {
        slidesPerView: 12,
        slidesPerGroup: 12,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.nextbutton',
          prevEl: '.prevbutton',
          disabledClass: 'my-button-disabled',
        },
      }
    }
  },
  created () {
    this.getData()

  },
  methods: {
    getData () {
      var that = this;
      fetch("/data.json").then((res) => {
        return res.json()
      }).then(data => {
        that.apiData = data.enLiteList;
      })
    },
    // 年份点击
    yearClick (year, index) {
      this.yearTagindex = index;
    },
  },
  components: {
    breadcrumbPage
  }
}
</script>

<style scoped>
.content {
    flex: 1;
    padding-top: 34px;
}
/* 商品部分 */
.product_bar {
    height: 370px;
    display: flex;
    border-bottom: 1px solid #ddd;
}
.imgTip {
    width: 324px;
}
.imgTip img {
    width: 100%;
}
.productWrap {
    flex: 1;
}
.p_title {
    font-size: 22px;
    font-weight: bold;
}
.p_title_sub {
    font-size: 16px;
    color: #ccc;
    margin-top: 12px;
    padding-bottom: 16px;
    border-bottom: 1px solid #ddd;
}
.p_instro_bar {
    display: flex;
    margin-top: 20px;
}
.top_instro {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 6px;
}
.down_instro {
    font-size: 16px;
    color: #ccc;
}
.p_btn_bara {
    margin-top: 40px;
}
.p_btn {
    display: inline-block;
    width: 200px;
    height: 40px;
    text-align: center;
    font-size: 14px;
    border-radius: 40px;
    line-height: 40px;
    color: #fff;
    background: #b70109;
    margin-right: 20px;
}
.anse {
    background: #00797a;
}
/* 时间部分 */
.timeSet {
    padding-bottom: 80px;
}
.timeLine {
    height: 100px;
    line-height: 100px;
}
.page_btn {
    color: #999;
    cursor: pointer;
    display: inline-block;
    width: 28px;
    height: 28px;
    text-align: center;
    line-height: 28px;
    border-radius: 30px;
    border: 1px solid #ccc;
}
.page_btn_active {
    background: #0b8686;
    color: #fff;
    border: 1px solid #0b8686;
}
.timeItem {
    width: 66px;
    height: 66px;
    border-radius: 66px;
    font-size: 18px;
    text-align: center;
    line-height: 66px;
    font-weight: bold;
    display: inline-block;
    color: #333;
}
.timeItem_active {
    background: linear-gradient(90deg, #3a9a9b, #007476);
    color: #fff;
}
/* 列表 */
.listNews {
    padding-left: 66px;
    margin-bottom: 20px;
    margin-top: 20px;
    height: 36px;
    line-height: 36px;
    position: relative;
}
.date {
    color: #ccc;
    font-size: 14px;
    margin-right: 20px;
}
.intro_text {
    color: #333;
    font-size: 14px;
}

/* 设置底部轮播  注意顺序 positionBtn*/
.positionBtn {
    margin-top: 20px;
    position: relative;
    width: 1240px;
}

.nextbutton,
.prevbutton {
    display: inline-block;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    box-sizing: border-box;
    border-radius: 30px;
    background: #0b8586;
    color: #fff;
    position: absolute;
    top: 28%;
    z-index: 10;
    cursor: pointer;
    outline: none;
}

.nextbutton {
    right: -30px;
    left: auto;
}

.prevbutton {
    right: auto;
    left: -30px;
}
.swiper-slide {
    text-align: center;
}
.my-button-disabled {
    background: #ddd;
    color: #999;
}
.listNews:hover {
    background: #f5f8fa;
}
.listNewsActive {
    display: none;
    position: absolute;
    left: 10px;
    top: 12px;
}
.listNews:hover .listNewsActive {
    display: block;
}
</style>
